(function($){

	/** --------------------------------------------------
	*   
	*   blocks - SELECT
	*
	*   TABLE OF CONTENTS
	*   drupal behaviour
	*   custom select
	*
	*   -------------------------------------------------- */




	/** --------------------------------------------------
		#drupal behaviour
		-------------------------------------------------- */
	
		Drupal.behaviors.select = {
			attach: function (context) {
	
				/* custom select: */
				// setupCustomSelect();
	
			}
		};
	
	
	
	
	/** --------------------------------------------------
		#custom select
		-------------------------------------------------- */
	
		function setupCustomSelect() {
			if(isCustomSelectAllowed()) {
				
				$(document).find('select').select2({
					allowClear: false,
					closeOnSelect: true,
					disabled: false,
					dropdownCssClass: 'sort-by-and-order__dropdown',
					multiple: false,
					selectOnClose: false,
					/* don't display the search-box: 
					 * (see https://select2.org/searching#single-select)
					 */
					minimumResultsForSearch: Infinity,
					dropdownParent: $('.page-wrapper')
				});
	
			}
		} /* setupCustomSelect */
	
		function isCustomSelectAllowed() {
			let customSelectIsAllowed = true;
	
			// detect user agents:
			var auparser = new UAParser();
			var auResult =  auparser.getResult();
			// -> os:
			var osname = auResult.os.name;
	
			// we do not want the custom select on:
			// - iOS
			// - Android
	
			var disallowedOSs = ['iOS', 'Android'];
			if(disallowedOSs.indexOf(osname) > -1) {
				customSelectIsAllowed = false;
			}
	
			return customSelectIsAllowed;
		} /* isCustomSelectAllowed */
	
	
	
	
	})(jQuery);